import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AppAuthService } from './@core/utils';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private appAuth: AppAuthService, private router: Router) {
  }

  canActivate() {
    return this.isMemberTokenValid();
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isMemberTokenValid();
  }

  private isMemberTokenValid(): Promise<boolean> | boolean {
    const valid = this.appAuth.isAuthenticated();

    if (!valid) {
      return this.router.navigateByUrl('/auth/login');
    }

    return valid;
  }
}
